<template>
  <div class="mainTabs-wrapper">
    <!-- Agency Screen -->
    <div v-show="isZeepliveBoxVisible">
      <div id="parentTabIn" class="parentTabIn" style="padding-top: 35px;">
        <span class="backArrowIcon" id="close" @click="viewClose('someStatus')">
          <img :src="downArrow" alt="Back Arrow" />
        </span>

        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <div
              class="nav-link"
              :class="{ active: activeTab === 'agencyTab' }"
              @click="activateTab('agencyTab')"
              role="tab"
            >
              Top Agency
            </div>
          </li>
        </ul>

        <div class="rankRewardInfoBtn" @click="showRankRewardInfoTab">
          <div class="header-infoIcon">
            <img :src="infoIcon" alt="Info Icon" />
          </div>
        </div>
      </div>

      <div class="tab-content">
        <div
          class="tab-pane"
          :class="{ active: activeTab === 'agencyTab' }"
          id="agencyTab"
          role="tabpanel"
        >
          <div class="tab-contentIn">
            <Agency />
          </div>
        </div>
      </div>
    </div>

    <!-- Ranking Reward Screen -->
    <div v-show="!isZeepliveBoxVisible" class="rankRewardInfoScreen">
      <div class="tab-contentIn">
        <div>
          <div class="headerWrapper rankRewardTopSec">
            <div id="goParentTab" @click="goBackToAgencyTab" class="backArrowIcon">
              <img :src="downArrow" alt="Back Arrow" />
            </div>
            <div class="rankingReward-HD">Ranking Rewards</div>
          </div>

          <div class="rankRewardContSec">
            <AgencyRankRewardInfoComponent
              v-if="isLoadedRankRewardInfoTab"
              :currentTab="activeTab"
              @tab-changed="handleTabChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import downArrow from "../../assets/images/back-blackArrow.svg";
import infoIcon from "../../assets/images/infoIcon.png";

// ✅ Static imports (most compatible with Android WebView)
import Agency from "../Agency/AgencyCompTab.vue";
import AgencyRankRewardInfoComponent from "../RankRewardInfoComponent/AgencyRankRewardInfoComponent.vue";

export default {
  name: "ParentTabComponentAgency",
  components: { Agency, AgencyRankRewardInfoComponent },
  data() {
    return {
      activeTab: "agencyTab",
      isZeepliveBoxVisible: true,
      downArrow,
      infoIcon,
      isLoadedRankRewardInfoTab: false,
    };
  },
  methods: {
    showRankRewardInfoTab() {
      this.isLoadedRankRewardInfoTab = true;
      this.isZeepliveBoxVisible = false;
    },
    goBackToAgencyTab() {
      this.isZeepliveBoxVisible = true;
      this.activeTab = "agencyTab";
    },
    activateTab(tabId) {
      this.isZeepliveBoxVisible = true;
      this.activeTab = tabId;
    },
    handleTabChange(tabId) {
      this.activateTab(tabId);
    },
    viewClose(status) {
      if (window.navigator.userAgent.indexOf("Android") > -1) {
        Android.viewClose(status);
      }
    },
  },
};
</script>
